import { Effect } from "../Materials/effect";
var name = 'passPixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nvoid main(void)\n{\ngl_FragColor=texture2D(textureSampler,vUV);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var passPixelShader = { name: name, shader: shader };
//# sourceMappingURL=pass.fragment.js.map